import { FlexProps } from '@chakra-ui/react';
import { GoalAccountInvestmentType } from '@common/types';
import GoalDetailItemLayout from './GoalDetailItemLayout';
import {
    GoalSectorsPieChart,
    GoalSectorsPieChartLegend,
} from './GoalSectorsPieChart';

export interface GoalDetailSectorsChartItemProps extends FlexProps {
    investmentType: GoalAccountInvestmentType;
    riskScore: number;
}

const GoalDetailSectorsChartItem = ({
    investmentType,
    riskScore,
    ...props
}: GoalDetailSectorsChartItemProps) => {
    return (
        <GoalDetailItemLayout
            {...props}
            leftComponent={
                <GoalSectorsPieChart
                    size={24}
                    investmentType={investmentType}
                    riskScore={riskScore}
                />
            }
            rightComponent={
                <GoalSectorsPieChartLegend
                    investmentType={investmentType}
                    riskScore={riskScore}
                    layoutDirection="vertical"
                />
            }
        />
    );
};

export default GoalDetailSectorsChartItem;
